export const fuseNavigationConfig = [
    {
        'id'      : 'applications',
        'title'   : 'You Logged as a Guest !',
        'type'    : 'group',
        'icon'    : 'apps',
    }
];


// WEBPACK FOOTER //
// ./src/fuse-configs/fuseNavigationConfig.js